import { Box } from '@mui/material';

import './../Home/home.scss';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const App = () => {
	const navigate = useNavigate();
	useEffect(() => {
		window.location.href = "/";
	}, [])

	return (
		<Box className="T_containner">

		</Box>
	)
}